import { render, staticRenderFns } from "./newYork.vue?vue&type=template&id=007a476c&scoped=true&"
import script from "./newYork.vue?vue&type=script&lang=js&"
export * from "./newYork.vue?vue&type=script&lang=js&"
import style0 from "./newYork.vue?vue&type=style&index=0&id=007a476c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007a476c",
  null
  
)

export default component.exports